import { OnInit, Component, ɵConsole } from "@angular/core";

import { HttpErrorResponse } from "@angular/common/http";
import { NzMessageService, NzNotificationService, id_ID } from "ng-zorro-antd";

import {
  GlobalComponent,
  Ordine,
  Result,
  Aziende,
} from "../../environments/global";
import { HomeComponent } from "../home.component";
import { IfStmt } from "@angular/compiler";
import { filter } from "minimatch";

@Component({
  selector: "app-ordini",
  templateUrl: "ordini.component.html",
  styleUrls: ["ordini.component.scss"],
})
export class OrdiniComponent implements OnInit {
  public isRestricted: boolean;

  // TABLE VARS
  formatterEuro = (value: number) => `€ ${value}`;
  parserEuro = (value: string) => value.replace("€ ", "");
  dataSet = [];
  public displayData = [...this.dataSet];
  editCache = {};
  sortName = null;
  sortValue = null;
  // COMPONENT VARS
  newOrdine: Ordine = {
    id: "",
    code: "",
    title: "",
    forecast: null,
    company: "Meneghetti",
    status: true,
    costM: 0,
    costH: 0,
    prize: false,
  } as Ordine;
  public newCodeError: string = "validating";
  public activeFilter: boolean = true;
  public prizeFilter: boolean = false;
  public orderFilter: string = "";
  public totStimato: number = 0;
  public totLavorato: number = 0;

  isLoading: boolean = true;
  companyData: Array<string> = Aziende;

  constructor(
    public g: GlobalComponent,
    public home: HomeComponent,
    private notification: NzNotificationService,
    private message: NzMessageService
  ) {
    this.setup();
  }
  // ################################################
  // CLASS: ON INIT
  ngOnInit() {
    this.setup();
    this.loadData();
    this.isRestricted = this.g.userLogin.restricted;
  }
  // ################################################
  // SETUP
  setup() {
    // SETUP INTERFACE
    this.g.menuState = 2;
    this.g.homeTitle = "Tabella Ordini";
  }
  // ################################################
  // LOAD DATA
  loadData() {
    this.isLoading = true;
    const query: string =
      "SELECT * from chk_orders WHERE `status`=" +
      (this.activeFilter ? "1" : "0") +
      (this.prizeFilter ? " and `prize`= 1" : "") +
      " ORDER BY `id` DESC";

    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.isLoading = false;

        this.dataSet = res.data;

        //if (this.prizeFilter) {
        // this.dataSet.forEach((e: Ordine) => {
        // this.calcH(e.id);
        // });
        //} else {
        // this.dataSet.forEach((e: Ordine) => {
        //  if (e.prize) {
        // this.calcH(e.id);
        //  }
        // });
        //}
        this.totStimato = 0;
        this.totLavorato = 0;

        this.dataSet.forEach((e: Ordine) => {
          if (e.prize) {
            this.totStimato += e.forecast;
            this.totLavorato += e.total;
          }
        });

        if (this.orderFilter.length > 0) {
          console.log("FILTRO", this.orderFilter);
        }

        this.updateEditCache();
        // console.log(this.dataSet);
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );
  }
  // ################################################
  // FILTER DATA
  filterChange(e) {
    if (this.orderFilter.length > 0) {
      var filter = this.dataSet.filter((e: Ordine) => {
        return (
          e.title.toUpperCase().indexOf(this.orderFilter.toUpperCase()) >= 0
        );
      });
      this.displayData = [...filter];
    } else {
      this.displayData = [...this.dataSet];
    }
  }
  // ################################################
  // SEARCH
  search() {}
  // ################################################
  // RESET
  reset() {}
  // ################################################
  // SORT
  sort(sort: { key: string; value: string }): void {
    this.sortName = sort.key;
    this.sortValue = sort.value;
    if (this.sortName) {
      this.displayData = [
        ...this.dataSet.sort((a, b) =>
          this.sortValue === "ascend"
            ? a[this.sortName] > b[this.sortName]
              ? 1
              : -1
            : b[this.sortName] > a[this.sortName]
            ? 1
            : -1
        ),
      ];
    } else {
      this.displayData = [...this.dataSet];
    }
  }

  startEdit(id: string): void {
    this.editCache[id].edit = true;
  }

  cancelEdit(id: string): void {
    this.editCache[id].edit = false;
  }

  saveNew(): void {
    const check = this.dataSet.findIndex(
      (item) => item.code === this.newOrdine.code
    );
    if (check !== -1) {
      this.notification.error(
        "Codice già esistente",
        "Attenzione: il codice inserito è già stato utilizzato.",
        { nzDuration: this.g.fastTime }
      );
      this.newCodeError = "error";
      return;
    }

    const query: string =
      'INSERT INTO chk_orders (`code`, `title`, `forecast`, `company`, `status`, `costM`, `costH`, `prize`) VALUES ("' +
      this.newOrdine.code +
      '","' +
      this.newOrdine.title +
      '","' +
      this.newOrdine.forecast +
      '","' +
      this.newOrdine.company +
      '",' +
      +this.newOrdine.status +
      "," +
      +this.newOrdine.costM +
      "," +
      +this.newOrdine.costH +
      "," +
      +this.newOrdine.prize +
      ")";
    console.log(query);
    this.isLoading = true;
    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.isLoading = false;
        if (res.error === false) {
          this.newOrdine.id = res.data.insertId;
          this.dataSet.push(this.newOrdine);

          this.newOrdine = {
            id: "",
            code: "",
            title: "",
            forecast: null,
            company: "",
            status: true,
          } as Ordine;
          this.newCodeError = "validating";

          this.message.success("Nuovo inserimento creato con successo!");
          this.updateEditCache();
        } else {
          this.notification.error(
            "Si è verificato un problema, si prega di riprovare tra qualche minuto.",
            res.message,
            { nzDuration: this.g.normalTime }
          );
          console.log(res);
        }
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto.",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );
  }

  saveEdit(id: string): void {
    const data: Ordine = this.editCache[id].data;
    const index = this.dataSet.findIndex((item) => item.id === id);

    const check = this.dataSet.findIndex((item) => item.code === data.code);
    if (check !== -1 && check !== index) {
      this.notification.error(
        "Codice già esistente",
        "Attenzione: il codice inserito è già stato utilizzato.",
        { nzDuration: this.g.fastTime }
      );
      return;
    }

    this.dataSet[index] = this.editCache[id].data;
    this.editCache[id].edit = false;
    const query: string =
      'UPDATE chk_orders SET `code`="' +
      data.code +
      '", `title`="' +
      data.title +
      '", `forecast`="' +
      data.forecast +
      '", `company`="' +
      data.company +
      '", `costM`="' +
      data.costM +
      '", `costH`="' +
      data.costH +
      '", `costMReal`="' +
      data.costMReal +
      '" WHERE `id`=' +
      data.id;
    this.isLoading = true;
    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.isLoading = false;
        if (res.error === false) {
          this.message.success("Modifica completata con successo!");
          this.updateEditCache();
        } else {
          this.notification.error(
            "Si è verificato un problema, si prega di riprovare tra qualche minuto.",
            res.message,
            { nzDuration: 0 }
          );
          console.log(res);
        }
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto.",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );
  }
  saveCheck(id: string): void {
    const data: Ordine = this.dataSet.find((item) => item.id === id);

    let query: string =
      "SELECT SUM(chk_times.h) AS h FROM chk_times WHERE `orderId`=" + id;
    this.g.mysql(query).subscribe((res: Result) => {
      if (data.status === false) {
        data.total = res.data[0].h ? res.data[0].h : 0;
      } else {
        data.total = null;
      }
      query =
        "UPDATE chk_orders SET `status`=" +
        (data.status === false ? 0 : 1) +
        (data.status === false
          ? ",`date`= '" + new Date().toISOString().substring(0, 10) + "'"
          : ",`date`=''") +
        ",`total`=" +
        data.total +
        " WHERE `id`=" +
        data.id;
      console.log(query);
      this.isLoading = true;
      this.g.mysql(query).subscribe(
        (resUpdate: Result) => {
          this.isLoading = false;
          if (resUpdate.error === false) {
            this.message.success("Modifica completata con successo!");
            this.loadData();
          } else {
            this.notification.error(
              "Si è verificato un problema, si prega di riprovare tra qualche minuto.",
              resUpdate.message,
              { nzDuration: 0 }
            );
            console.log(resUpdate);
          }
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.notification.error(
            "Si è vericato un errore non previsto.",
            error.statusText,
            { nzDuration: 0 }
          );
        }
      );
    });
  }
  savePrize(id: string): void {
    const data: Ordine = this.dataSet.find((item) => item.id === id);
    const prize = data.prize === true ? 1 : 0;

    let query =
      "UPDATE chk_orders SET `prize`=" + prize + " WHERE `id`=" + data.id;
    // console.log(query);
    this.isLoading = true;
    this.g.mysql(query).subscribe(
      (resUpdate: Result) => {
        this.isLoading = false;
        if (resUpdate.error === false) {
          this.message.success("Modifica completata con successo!");
          this.loadData();
        } else {
          this.notification.error(
            "Si è verificato un problema, si prega di riprovare tra qualche minuto.",
            resUpdate.message,
            { nzDuration: 0 }
          );
          // console.log(resUpdate);
        }
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto.",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );
  }
  deleteRow(id: string): void {
    const index = this.dataSet.findIndex((item) => item.id === id);
    const query: string =
      'DELETE FROM chk_orders WHERE `code`= "' + this.dataSet[index].code + '"';
    this.isLoading = true;
    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.isLoading = false;
        if (res.error === false) {
          this.dataSet.splice(index, 1);
          this.message.success("Cancellazione completata con successo!");
          this.updateEditCache();
        } else {
          this.notification.error(
            "Si è verificato un problema, si prega di riprovare tra qualche minuto.",
            res.message,
            { nzDuration: 0 }
          );
          console.log(res);
        }
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto.",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );
  }

  updateEditCache(): void {
    if (this.dataSet != null) {
      this.dataSet.forEach((item) => {
        if (!this.editCache[item.id]) {
          this.editCache[item.id] = {
            edit: false,
            data: item,
          };
        }
      });
    }
    if (this.orderFilter.length > 0) {
      this.filterChange(null);
    } else {
      this.displayData = [...this.dataSet];
    }
  }

  calcH(orderId: string) {
    const query: string =
      "SELECT SUM(chk_times.h) AS h FROM chk_times" +
      " WHERE `orderId`=" +
      orderId;
    this.g.mysql(query).subscribe((res: Result) => {
      const index = this.dataSet.findIndex((item) => item.id === orderId);
      this.dataSet[index].total = res.data[0].h ? res.data[0].h : 0;
    });
  }

  isNull(val) {
    return typeof val === "number";
  }

  calcPrize(o: Ordine) {
    var deltaH;
    if (o.forecast != 0) deltaH = o.forecast - o.total;
    else deltaH = o.total;
    //if (deltaH <= 0) return 0;
    const costH = deltaH * o.costH;
    const costM = o.costM - o.costMReal;

    const prizeValue = Math.round((costH + costM) / 2);
    return prizeValue;
  }
}
